import * as constants from './constants';

export const getBarcodeItems = () => ({ type: constants.GET_BARCODE_ITEMS });
export const getBarcodeItemsSuccess = (payload) => ({
  type: constants.GET_BARCODE_ITEMS_SUCCESS,
  payload,
});
export const getBarcodeItemsError = (payload) => ({
  type: constants.GET_BARCODE_ITEMS_ERROR,
  payload,
});

export const selectItem = (payload) => ({ type: constants.SELECT_BARCODE_ITEM, payload });
export const deselectItem = (payload) => ({ type: constants.DESELECT_BARCODE_ITEM, payload });

export const resetBarcodeItems = () => ({ type: constants.RESET_BARCODE_ITEMS });
export const resetBarcodeItemsActions = () => ({ type: constants.RESET_BARCODE_ITEMS_ACTIONS });
// export const openBarcodeItem = (payload) => ({ type: constants.OPEN_BARCODE_ITEM, payload });
// export const closeBarcodeItem = () => ({ type: constants.CLOSE_BARCODE_ITEM });

export const setBarcodeItemsFilters = (payload) => ({
  type: constants.SET_BARCODE_ITEMS_FILTERS,
  payload,
});

// export const setBarcodeItemsQuery = (payload) => ({
//   type: constants.SET_BARCODE_ITEMS_QUERY,
//   payload,
// });

export const validateBarcodeItem = (payload) => ({ type: constants.VALIDATE_BARCODE_ITEM, payload });
export const validateBarcodeItemSuccess = (payload) => ({ type: constants.VALIDATE_BARCODE_ITEM_SUCCESS, payload });
export const validateBarcodeItemError = () => ({ type: constants.VALIDATE_BARCODE_ITEM_ERROR });

export const searchBarcodeItem = (payload) => ({ type: constants.SEARCH_BARCODE_ITEM, payload });
export const searchBarcodeItemSuccess = (payload) => ({ type: constants.SEARCH_BARCODE_ITEM_SUCCESS, payload });
export const searchBarcodeItemError = () => ({ type: constants.SEARCH_BARCODE_ITEM_ERROR });
